import * as Sentry from '@sentry/gatsby'

const dsn = process.env.GATSBY_SENTRY_DSN

if (dsn) {
    Sentry.init({
        dsn,
        environment:
            process.env.GATSBY_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
        enableLogs: true,
        tracesSampleRate: Number(
            process.env.GATSBY_SENTRY_TRACES_SAMPLE_RATE || '0'
        ),
        sendDefaultPii: false,
    })
}
